import React, { useState } from "react";
import { toast } from "react-toastify";
import { base_url } from "../../../config";

const ProfileImage = ({ userProfile, fetchProfileData }) => {
  const [image, setImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleImageChange = async (event) => {
    const file = event.target.files[0];

    if (file) {
      setImage(URL.createObjectURL(file));
      setSelectedFile(file);

      const accessToken = localStorage.getItem("@user");

      if (!accessToken) {
        alert("Access token is missing. Please log in again.");
        return;
      }

      const formData = new FormData();
      formData.append("photo", file);

      try {
        const response = await fetch(`${base_url}/profile-members/photo-upload`, {
          method: "POST",
          headers: { Authorization: `Bearer ${accessToken}` },
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          fetchProfileData();
          toast.success("Profile Photo updated successfully!", {
            position: "top-right",
          });
          console.log("Response:", data);
          //   window.location.reload();
        } else {
          alert("Failed to upload image.");
          console.error("Error:", await response.text());
        }
      } catch (error) {
        console.error("Error during image upload:", error);
        alert("An error occurred while uploading the image.");
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <label
        htmlFor="fileInput"
        className="cursor-pointer flex items-center justify-center
        w-28 h-28 mb-5 overflow-hidden relative"
      >
        {image ? (
          <div className="flex flex-col items-center justify-center">
            <img
              src={image}
              alt="Uploaded"
              className="object-cover w-24 h-24 rounded-full"
            />
            <div className="absolute bottom-2 right-2 bg-white p-1 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="w-6 h-6 text-gray-500 -mt-7 -ml-9 border-2 bg-white border-white rounded-full"
                viewBox="0 0 16 16"
              >
                <path d="M8 1a7 7 0 1 0 7 7A7 7 0 0 0 8 1zm3 8H9v3H7V9H4V7h3V4h2v3h3z" />
              </svg>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center">
            <div
              className="bg-gray-500 w-24 h-24 rounded-full bg-cover bg-center"
              style={{
                backgroundImage: `url(${userProfile?.photo || ""})`,
              }}
            ></div>

            <div className="absolute bottom-2 right-0 bg-white p-1 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="w-6 h-6 text-gray-500 -mt-7 -ml-9 border-2 bg-white border-white rounded-full"
                viewBox="0 0 16 16"
              >
                <path d="M8 1a7 7 0 1 0 7 7A7 7 0 0 0 8 1zm3 8H9v3H7V9H4V7h3V4h2v3h3z" />
              </svg>
            </div>
          </div>
        )}
      </label>
      <input
        id="fileInput"
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleImageChange}
      />
    </div>
  );
};

export default ProfileImage;
